<template>
  <div class="my_index_container">
    <div class="my_index_head">
      <img src="../assets/img/001.png" alt="">
    </div>
    <div class="my_index_container">
      <!-- 社区生态 -->
      <div class="my_index_item index_community">
        <div class="index_glag_head">
          <p class="index_glag_head_title lf">社区生态</p>
          <p class="index_glag_head_content lf">
            零距离聆听专家大咖的真知灼见和独家看法
          </p>
        </div>
        <div class="index_community_container">
          <div v-if="communityList.length > 0" class="index_community_left" @mouseenter="shadshow.communityLeft = true" @mouseleave="shadshow.communityLeft = false">
            <div v-if="shadshow.communityLeft" class="index_community_left_shadow">
              <button v-if="communityAct.is_doing === 0" class="my_follow_btn" @click="allJump(communityAct.type, communityAct.list_id, communityAct.nav_id, communityAct.is_doing)">前往报名</button>
              <button v-if="communityAct.is_doing === 1" class="my_follow_btn" @click="allJump(communityAct.type, communityAct.list_id, communityAct.nav_id, communityAct.is_doing)">进入直播间</button>
            </div>
            <img v-if="communityAct.is_doing !== 1 && communityAct.is_doing !== 5" :src="communityAct.img" alt="封面" :onerror="defaultImg">
            <video-view v-if="communityAct.is_doing === 5" :detail="communityAct" :src-arr="communityAct.video_path" :bg-img="communityAct.img" :video-type="videoType" :key="communityAct.list_id"></video-view>
            <live-view v-if="communityAct.is_doing === 1" :chat-info="communityAct"></live-view>
          </div>
          <div v-if="communityList.length > 0" class="index_community_right">
            <div v-for="(item, index) in communityList"
            :key="item.id"
            @click = "getCommunityAct(item, index)">
              <div class="index_community_right_item" :class="communityActIndex === index ? 'act' : ''">
                <div class="index_community_right_item_pic">
                  <img v-if="item.is_doing === 2" :src="item.room_img" alt="封面" :onerror="defaultImg">
                  <img v-else :src="item.room_img" alt="封面" :onerror="defaultImg">
                  <p v-if="item.is_doing === 0">预告</p>
                  <p v-if="item.is_doing === 1">进行中</p>
                </div>
                <div class="index_community_right_item_info">
                  <p class="index_community_right_title">{{item.title}}</p>
                  <p class="index_community_right_user">{{item.nav_name}}</p>
                  <div v-if="item.price !== '0.00'">
                    <span>¥<i class="font_i">{{item.price}}</i></span>
                  </div>
                  <div v-if="item.is_doing === 0 && item.price === '0.00'" class="index_community_right_other">
                    <span><i class="font_i">{{item.sign_count}}</i> 人报名</span>
                  </div>
                  <div v-if="item.is_doing === 1 && item.price === '0.00'" class="index_community_right_other">
                    <span><i class="font_i">{{item.on_count}}</i> 人正在观看</span>
                  </div>
                  <div v-if="item.is_doing === 5 && item.price === '0.00'" class="index_community_right_other">
                    <span><i class="font_i">{{item.count}}</i> 人参与</span>
                    <el-divider direction="vertical"></el-divider>
                    <span><i class="font_i">{{item.comment_count}}</i> 条评论</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 联盟生态 -->
      <div class="my_index_item index_union">
        <div class="index_union_box">
          <div class="index_union_head">
            <p class="index_union_head_title">联盟生态</p>
            <p class="index_union_head_content">
              行业企业精英汇聚一堂    开发有价值的项目   推动社会健康发展
            </p>
          </div>
          <div class="index_union_contaier">
            <div class="index_union_contaier_nav">
              <div class="index_union_contaier_nav_box">
                <div class="index_union_contaier_nav_industry lf">
                  <p class="index_union_contaier_nav_left">行业<br>联盟</p>
                  <ul class="index_union_contaier_nav_right">
                    <li v-for="item in industryNav"
                    :key="item.id"
                    class="index_union_contaier_nav_item lf"
                    :class="unionNavIndex === item.id ? 'act' : ''"
                    @click="unionSwitch(item.id)">
                      <i></i>
                      {{item.union_name}}
                    </li>
                  </ul>
                </div>
                <div class="index_union_contaier_nav_major lf">
                   <p class="index_union_contaier_nav_left">专业<br>联盟</p>
                   <ul class="index_union_contaier_nav_right">
                     <li v-for="item in majorNav"
                     :key="item.id"
                     class="index_union_contaier_nav_item lf"
                     :class="unionNavIndex === item.id ? 'act' : ''">
                       <i></i>
                       {{item.union_name}}
                     </li>
                   </ul>
                </div>
              </div>
            </div>
            <div class="index_union_contaier_left lf">
              <div class="index_union_discuss lf">
                <div class="index_top_title">
                  <p class="index_top_title_lf lf">
                    <span>研讨</span>沙龙
                  </p>
                  <p class="index_top_title_rt rt">
                    <router-link class="rt" :to="{ path: '/discussList', query: { id: unionNavIndex } }" >MORE<i class="my_icon_list more_icon"></i></router-link>
                  </p>
                </div>
                <div class="index_union_discuss_list">
                  <el-carousel height="276px">
                    <el-carousel-item v-for="item in discussList" :key="item.id">
                      <img @click="allJump(item.type, item.list_id, 15, item.is_doing)" :src="item.img" alt="封面" :onerror="defaultImg">
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
              <div class="index_union_roadshow rt">
                <div class="index_top_title">
                  <p class="index_top_title_lf lf">
                    <span>项目</span>路演
                  </p>
                  <p class="index_top_title_rt rt">
                    <router-link class="rt" :to="{ path: '/roadshowList', query: { id: unionNavIndex } }" >MORE<i class="my_icon_list more_icon"></i></router-link>
                  </p>
                </div>
                <div class="index_union_roadshow_list">
                  <dl class="index_union_roadshow_item lf" v-for="item in roadshowList" :key="item.id">
                    <dt
                    :class="item.type !== 3 ? 'video_box_shadow_box' : ''"
                    v-if="item.img !== ''"
                    @click="allJump(item.type, item.list_id, 16)">
                      <div v-if="item.type !== 3" class="video_box_shadow">
                        <i class="my_icon_list player_icon"></i>
                      </div>
                      <img v-if="item.img !== ''" :src="item.img" alt="封面" :onerror="defaultImg">
                      <i></i>
                    </dt>
                    <dt v-else @click="allJump(item.type, item.list_id, 16)">
                      暂无封面
                    </dt>
                    <dd @click="allJump(item.type, item.list_id, 16)">
                    {{item.title}}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
            <div class="index_union_contaier_right rt">
              <div class="index_union_object">
                <div class="index_top_title">
                  <p class="index_top_title_lf lf">
                    <span>项目</span>合作
                  </p>
                  <p class="index_top_title_rt rt">
                    <router-link class="rt" :to="{ path: '/cooperationList', query: { id: unionNavIndex } }" >MORE<i class="my_icon_list more_icon"></i></router-link>
                  </p>
                </div>
                <ul class="index_union_object_list">
                  <li v-for="item in objectList" :key="item.id" class="index_union_object_item">
                    <div class="index_union_object_info">
                      <img :src="item.portrait" alt="头像" :onerror="defaultImg">
                      <dl>
                        <dt @click="userJump(item.user_id)">{{item.user_name}}</dt>
                        <dd>{{item.add_time}}</dd>
                      </dl>
                    </div>
                    <div class="index_union_object_content" @click="allJump(item.type, item.list_id, 30)">
                      {{item.content}}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="index_union_contaier_bottom lf">
              <div class="index_union_train">
                <dl class="index_union_train_title">
                  <dt><span>精品</span>培训</dt>
                  <dd class="">
                    <router-link class="rt" :to="{ path: '/trainList', query: { id: unionNavIndex } }" >更多<i class="my_icon_list more_icon_circle"></i></router-link>
                  </dd>
                </dl>
                <div class="index_union_train_list">
                  <dl v-for="(item ,index) in trainList" :key="item.id" class="index_union_train_item lf" @click = "trainJump(item.is_buy, index)">
                    <dt>
                      <div v-if="item.img !== ''" class="video_box_shadow">
                        <i class="my_icon_list player_icon"></i>
                      </div>
                      <img :src="item.img" alt="">
                    </dt>
                    <dd>
                      <p class="index_union_train_item_title">
                        <i v-if="item.is_buy === 1 && item.price !== '0.00'" class="reception_live_title_tag">已购买</i>
                        {{item.title}}
                      </p>
                      <p class="index_union_train_item_other">
                        <span class="lf" v-if="item.price === '0.00'"><u>免费</u></span>
                        <span class="lf" v-else><u>¥{{item.price}}</u></span>
                        <span class="rt"><i>{{item.read}}</i>人培训</span>
                      </p>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 研究院生态 -->
      <div class="my_index_item index_research">
        <div class="index_research_box">
          <div class="index_glag_head">
            <p class="index_glag_head_title lf">研究院生态</p>
            <p class="index_glag_head_content lf">
              推出研究成果   打造行业中坚智库
            </p>
          </div>
          <div class="index_research_container">
            <div class="index_research_research_nav">
              <div class="index_research_research_nav_box">
                <ul id="index_research_research_nav_ul">
                  <li v-for="item in researchList"
                  :key="item.id"
                  class="index_research_research_nav_item"
                  :class="researchNavIndex === item.research_id ? 'act' : ''"
                  @click="researchSwitch(item.research_id)"
                  >
                    {{item.research_name}}
                    <i></i>
                  </li>
                </ul>
                <div class="index_research_research_page index_research_research_page_left" @click="researchSlid('prev', 960)">&lt;&lt;</div>
                <div class="index_research_research_page index_research_research_page_right" @click="researchSlid('next', 960)">&gt;&gt;</div>
              </div>
            </div>
            <div class="index_research_research lf">
              <div class="index_top_title">
                <p class="index_top_title_lf lf">
                  <span>研究</span>学院
                </p>
                <p class="index_top_title_rt rt">
                  <router-link class="rt" :to="{ path: '/research/:id', query: { id: researchNavIndex } }" >MORE<i class="my_icon_list more_icon"></i></router-link>
                </p>
              </div>
              <div class="index_research_research_pic">
                <span v-if="researchImg.length === 0">暂无图片</span>
                <img v-else :src="researchImg[0].path" alt="">
              </div>
              <div class="index_research_research_list">
                <div class="index_research_research_item" v-for="item in newPostList" :key="item.id">
                  <div class="index_research_research_title" @click="allJump(3, item.list_id, item.nav_id)">
                    <i class="my_icon_list index_research_list"></i>
                    {{item.title}}
                  </div>
                  <div class="index_research_research_content">
                    {{item.content}}
                  </div>
                </div>
              </div>
            </div>
            <div class="index_research_rt rt">
              <div class="index_research_book">
                <div class="index_top_title">
                  <p class="index_top_title_lf lf">
                    <span>出版物</span>
                  </p>
                  <p class="index_top_title_rt rt">
                    <router-link class="rt" :to="{ path: '/bookList', query: { id: researchNavIndex } }" >MORE<i class="my_icon_list more_icon"></i></router-link>
                  </p>
                </div>
                <div class="index_research_book_list">
                  <el-carousel :interval="3000" arrow="always">
                    <el-carousel-item v-for="item in bookList" :key="item.id">
                      <dl>
                        <dt>
                          <img :src="item.book_img" alt="" @click="allJump(3, item.list_id, 29)">
                        </dt>
                        <dd>{{item.title}}</dd>
                      </dl>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
            <div class="index_research_lf lf">
              <div class="index_research_learning">
                <div class="index_top_title">
                  <p class="index_top_title_lf lf">
                    <span>学术</span>交流
                  </p>
                  <p class="index_top_title_rt rt">
                    <router-link class="rt" :to="{ path: '/learningList', query: { id: researchNavIndex } }" >MORE<i class="my_icon_list more_icon"></i></router-link>
                  </p>
                </div>
                <div class="index_research_learning_list">
                    <div class="index_research_learning_item lf" v-for="item in learningList" :key="item.id">
                      <div class="index_research_learning_pic">
                        <img :src="item.portrait" alt="">
                      </div>
                      <div class="index_research_learning_info">
                        <div class="index_research_learning_title">
                          <a @click="allJump(item.type, item.list_id, 23)">{{item.title}}</a>
                        </div>
                        <div class="index_research_learning_content">
                          {{item.content}}
                        </div>
                        <div class="index_research_learning_other">
                          <el-breadcrumb separator="|">
                            <el-breadcrumb-item class="my_icon_box"><a @click="jump(item.list_id, 23)"><i class="my_icon dianzan"></i><span class="my_icon_text">{{item.comment_count}}</span></a></el-breadcrumb-item>
                            <el-breadcrumb-item class="my_icon_box"><a @click="jump(item.list_id, 23)"><i class="my_icon pinglun"></i><span class="my_icon_text">{{item.like}}</span></a></el-breadcrumb-item>
                            <el-breadcrumb-item class="my_icon_box"><a @click="jump(item.list_id, 23)"><i class="my_icon shoucang"></i><span class="my_icon_text">{{item.favorites}}</span></a></el-breadcrumb-item>
                            <el-breadcrumb-item class="my_icon_box r_border"><a @click="jump(item.list_id, 23)"><i class="my_icon fenxiang"></i><span class="my_icon_text">{{item.share}}</span></a></el-breadcrumb-item>
                            <el-breadcrumb-item></el-breadcrumb-item>
                          </el-breadcrumb>
                        </div>
                      </div>
                    </div>
                  </div>

              </div>
            </div>
            <div class="index_research_rt rt">
              <div class="index_research_down">
                <div class="index_top_title">
                  <p class="index_top_title_lf lf">
                    <span>研究</span>成果
                  </p>
                  <p class="index_top_title_rt rt">
                    <router-link class="rt" :to="{ path: '/findingsList', query: { id: researchNavIndex } }" >MORE<i class="my_icon_list more_icon"></i></router-link>
                  </p>
                </div>
                <div class="index_research_down_box">
                  <div class="index_research_down_item" v-for="(item,index) in reportList" :key="item.id">
                    <div v-if="index === 0" class="index_research_down_num first_label">{{index + 1}}</div>
                    <div v-if="index === 1" class="index_research_down_num two_label">{{index + 1}}</div>
                    <div v-if="index === 2" class="index_research_down_num three_label">{{index + 1}}</div>
                    <div v-if="index > 2" class="index_research_down_num glay_label">{{index + 1}}</div>
                    <div class="index_research_down_info">
                      <p class="index_research_down_title">
                      <a @click="jump(item.list_id, 22)">{{item.title}}</a>
                      </p>
                      <p class="index_research_down_other"></p>
                      <div class="index_research_down_other">
                        <span>{{item.read}}人浏览</span>
                        <el-divider direction="vertical"></el-divider>
                        <span>{{item.download}}人下载</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videoModel from './Public/video.vue'
export default {
  components: {
    videoView: videoModel
  },
  data () {
    return {
      defaultImg: 'this.src="' + require('../assets/img/other/imgError.png') + '"',
      hoverIndex: '', // 入驻企业鼠标移入记录下标
      shadshow: {
        communityLeft: false // 会客厅左侧遮罩层
      },
      videoType: 'index', // 视频属性
      communityAct: {}, // 当前播放
      communityActIndex: 0, // 当前选中下标
      communityList: [], // 会客厅
      industryNav: [], // 联盟导航
      majorNav: [], // 联盟导航
      unionNavIndex: '', // 当前选中联盟
      discussList: [], // 研讨沙龙
      trainList: [], // 培训
      objectList: [], // 项目合作
      roadshowList: [], // 项目路演
      researchList: [], // 研究院
      researchNavIndex: '', // 当前选中研究院
      researchImg: [], // 研究院图片
      newPostList: [], // 最新发布
      bookList: [], // 出版物
      learningList: [], // 学术交流
      reportList: [], // 报告下载
      // 下载列表弹窗开关
      downDialogOnOff: false,
      // 下载列表数据
      downDialogList: []
    }
  },
  async created () {
    await this.getHomePage() // 获取社区生态列表
  },
  methods: {
    // 获取首页信息
    getHomePage () {
      const vueThat = this
      vueThat.myApi.homePage().then((res) => {
        if (res.data.code === 200) {
          vueThat.communityList = res.data.data.community_ecology
          if (vueThat.communityList.length > 0) {
            vueThat.communityAct = vueThat.communityList[0]
          }
          for (let i = 0; i < res.data.data.union.union_list.length; i++) {
            if (res.data.data.union.union_list[i].type === 'industry') {
              vueThat.industryNav.push(res.data.data.union.union_list[i])
            } else {
              vueThat.majorNav.push(res.data.data.union.union_list[i])
            }
          }
          vueThat.unionNavIndex = vueThat.industryNav[0].id
          vueThat.discussList = res.data.data.union.list
          vueThat.trainList = res.data.data.union.train
          vueThat.objectList = res.data.data.union.cooperation
          vueThat.roadshowList = res.data.data.union.roadshow
          vueThat.researchList = res.data.data.research.research_list
          vueThat.researchImg = res.data.data.research.img
          vueThat.researchNavIndex = res.data.data.research.research_list[0].research_id
          vueThat.newPostList = res.data.data.research.new_post
          vueThat.bookList = res.data.data.research.book_list
          vueThat.learningList = res.data.data.research.learning
          vueThat.reportList = res.data.data.research.achievements
        }
      })
    },
    // 当前播放直播间
    getCommunityAct (obj, index) {
      this.communityAct = obj
      this.communityActIndex = index
    },
    // 研究院导航平移
    researchSlid (type, num) {
      const ul = document.getElementById('index_research_research_nav_ul')
      if (type === 'next') {
        ul.style.right = num + 'px'
      } else {
        ul.style.right = 0
      }
    },
    // 联盟生态切换
    unionSwitch (rid) {
      const vueThat = this
      vueThat.myApi.homeEcology({ union_id: rid }).then((res) => {
        if (res.data.code === 200) {
          vueThat.unionNavIndex = rid
          vueThat.discussList = res.data.data.list
          vueThat.trainList = res.data.data.train
          vueThat.objectList = res.data.data.cooperation
          vueThat.roadshowList = res.data.data.roadshow
        }
      })
    },
    // 联盟生态切换
    researchSwitch (rid) {
      const vueThat = this
      vueThat.myApi.homeResearch({ research_id: rid }).then((res) => {
        console.log(res)
        if (res.data.code === 200) {
          vueThat.researchNavIndex = rid
          vueThat.researchList = res.data.data.research_list
          vueThat.researchImg = res.data.data.img
          vueThat.newPostList = res.data.data.new_post
          vueThat.bookList = res.data.data.book_list
          vueThat.learningList = res.data.data.learning
          vueThat.reportList = res.data.data.achievements
        }
      })
    },
    allJump (type, id, navId, isDoing) {
      this.mycommon.allJump(this, type, id, navId, isDoing)
    },
    trainJump (buy, index) {
      if (buy === 0 && this.trainList[index].price !== '0.00') {
        this.$alert('本视频为付费视频，请您下载APP，完成支付！', '温馨提示', {
          type: 'error',
          confirmButtonText: '下载APP',
          showClose: true
        }).then(() => {
          const routeData = this.$router.resolve({
            path: '/down'
          })
          window.open(routeData.href, '_blank')
        })
      } else {
        this.allJump(2, this.trainList[index].list_id, 14)
      }
    },
    // 跳转详情
    jump (id, navId, isDoing) {
      this.mycommon.detailJump(this, id, navId, isDoing)
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped="scoped">
.my_index_head{
  width: 100%;
  min-width: 1100px;
}
</style>
